'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildMessageFromType = undefined;

var _messageTypeBuildersM;

var _messageTypes = require('../../pubnub-message/constants/messageTypes');

var _messageType = require('../../initial-message/constants/messageType');

var _buildInitialMessage = require('../../initial-message/operators/buildInitialMessage');

var _isPubnubMessageRecord = require('../../pubnub-message/operators/isPubnubMessageRecord');

var _getMessageType = require('../../pubnub-message/operators/getMessageType');

var _buildPublishedMessage = require('../../factories/PubNubMessageFactory/buildPublishedMessage');

var _buildCommonMessage = require('../../common-message-format/operators/buildCommonMessage');

var _buildCommentMessage = require('../../comment-message-metadata/operators/buildCommentMessage');

var _CrmObjectLifecycleUpdate = require('../../crm-object-lifecycle-update/records/CrmObjectLifecycleUpdate');

var _CrmObjectLifecycleUpdate2 = _interopRequireDefault(_CrmObjectLifecycleUpdate);

var _ContextUpdateMessage = require('../../context-update/records/ContextUpdateMessage');

var _ContextUpdateMessage2 = _interopRequireDefault(_ContextUpdateMessage);

var _CrmObjectWorkflowEmailSent = require('../../crm-object-workflow-email-sent/records/CrmObjectWorkflowEmailSent');

var _CrmObjectWorkflowEmailSent2 = _interopRequireDefault(_CrmObjectWorkflowEmailSent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var messageTypeBuildersMap = (_messageTypeBuildersM = {}, _defineProperty(_messageTypeBuildersM, _messageTypes.COMMON_MESSAGE, _buildCommonMessage.buildCommonMessage), _defineProperty(_messageTypeBuildersM, _messageType.INITIAL_MESSAGE, _buildInitialMessage.buildInitialMessage), _defineProperty(_messageTypeBuildersM, _messageTypes.CRM_OBJECT_LIFECYCLE_UPDATE, function (messageObject) {
  return new _CrmObjectLifecycleUpdate2.default(messageObject);
}), _defineProperty(_messageTypeBuildersM, _messageTypes.CRM_OBJECT_WORKFLOW_EMAIL_SENT, function (messageObject) {
  return new _CrmObjectWorkflowEmailSent2.default(messageObject);
}), _defineProperty(_messageTypeBuildersM, _messageTypes.THREAD_COMMENT, _buildCommentMessage.buildCommentMessage), _defineProperty(_messageTypeBuildersM, _messageTypes.CONTEXT_UPDATE, function (messageObject) {
  return new _ContextUpdateMessage2.default(messageObject);
}), _messageTypeBuildersM);

var buildMessageFromType = exports.buildMessageFromType = function buildMessageFromType(message) {
  var builder = messageTypeBuildersMap[(0, _getMessageType.getMessageType)(message)];

  if (builder) {
    return builder(message);
  } else if (!(0, _isPubnubMessageRecord.isPubnubMessageRecord)(message)) {
    return (0, _buildPublishedMessage.buildPublishedMessage)(message);
  }

  return message;
};